module.exports = __webpack_public_path__ + "img/background-mobile.dd07c2cf.png";